import { TRPCClientError } from '@trpc/client'
import type { AnyProcedure, inferRouterInputs, inferRouterOutputs } from '@trpc/server'

import type { AppRouter } from '~/server/trpc/routers'

export type RouterInput = inferRouterInputs<AppRouter>
export type RouterOutput = inferRouterOutputs<AppRouter>

export function isTRPCClientError<T extends AppRouter | AnyProcedure = AppRouter>(cause: unknown): cause is TRPCClientError<T> {
  return cause instanceof TRPCClientError
}
